import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromWorkflow from './state/workflow.reducers';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(fromWorkflow.WORKFLOW_FEATURE_KEY, fromWorkflow.reducer)],
})
export class WorkflowCommonDataAccessModule {}
